import { useState } from 'react';

interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  duration: string;
  category: string;
  embedUrl: string;
  featured?: boolean;
}

export default function VideoGallery() {
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
  const [activeCategory, setActiveCategory] = useState('All');

  const videos: Video[] = [
    {
      id: '1',
      title: 'Journey from Darkness to Light',
      description: 'Melinda shares her powerful testimony of overcoming childhood trauma and finding healing through faith and resilience.',
      thumbnail: 'https://public.readdy.ai/ai/img_res/7124c4fbc2ad442a9696e2bb39e632da.jpg',
      duration: '12:45',
      category: 'Testimony',
      embedUrl: 'https://www.youtube.com/embed/dhKOh9BulH8',
      featured: true
    },
    {
      id: '2',
      title: 'The Power of Vulnerability in Healing',
      description: 'Brené Brown discusses how embracing vulnerability can lead to profound healing and personal transformation after trauma.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20TED%20talk%20style%20video%20thumbnail%20with%20speaker%20on%20stage%2C%20warm%20spotlight%20lighting%2C%20audience%20silhouettes%20in%20background%2C%20inspiring%20and%20empowering%20atmosphere%2C%20modern%20conference%20setting%20with%20simple%20clean%20background%2C%20motivational%20speaking%20environment&width=800&height=450&seq=video-thumb-007&orientation=landscape',
      duration: '20:19',
      category: 'Inspiration',
      embedUrl: 'https://www.youtube.com/embed/iCvmsMzlF7o'
    },
    {
      id: '3',
      title: 'Understanding PTSD and Recovery',
      description: 'An educational exploration of Post-Traumatic Stress Disorder, its effects, and evidence-based approaches to healing and recovery.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Educational%20medical%20video%20thumbnail%20with%20calm%20professional%20therapist%20in%20modern%20bright%20office%2C%20soft%20natural%20lighting%2C%20peaceful%20counseling%20room%20with%20plants%20and%20comfortable%20seating%2C%20reassuring%20and%20informative%20atmosphere%2C%20clean%20professional%20healthcare%20setting&width=800&height=450&seq=video-thumb-008&orientation=landscape',
      duration: '15:42',
      category: 'Education',
      embedUrl: 'https://www.youtube.com/embed/b_n9qegR7C4'
    },
    {
      id: '4',
      title: 'From Trauma to Triumph',
      description: 'Inspiring stories of individuals who transformed their traumatic experiences into sources of strength, purpose, and hope for others.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Uplifting%20documentary%20style%20video%20thumbnail%20showing%20person%20standing%20on%20mountain%20peak%20at%20sunrise%2C%20arms%20raised%20in%20victory%2C%20golden%20hour%20lighting%2C%20triumphant%20and%20hopeful%20mood%2C%20inspiring%20landscape%20with%20vast%20sky%2C%20symbol%20of%20overcoming%20challenges%20and%20personal%20growth&width=800&height=450&seq=video-thumb-009&orientation=landscape',
      duration: '18:30',
      category: 'Inspiration',
      embedUrl: 'https://www.youtube.com/embed/iseestars'
    },
    {
      id: '5',
      title: 'The Science of Resilience',
      description: 'Discover the neuroscience behind resilience and learn practical strategies for building mental strength after experiencing trauma.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Scientific%20educational%20video%20thumbnail%20with%20brain%20imagery%20and%20neural%20pathways%2C%20modern%20medical%20visualization%2C%20professional%20healthcare%20presentation%20style%2C%20clean%20white%20and%20teal%20color%20scheme%2C%20informative%20and%20trustworthy%20atmosphere%2C%20high-quality%20medical%20education%20aesthetic&width=800&height=450&seq=video-thumb-010&orientation=landscape',
      duration: '22:15',
      category: 'Education',
      embedUrl: 'https://www.youtube.com/embed/NWH8N-BvhAw'
    },
    {
      id: '6',
      title: 'Finding Hope After Loss',
      description: 'A compassionate discussion about navigating grief, processing trauma, and discovering renewed purpose and meaning in life.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Gentle%20compassionate%20video%20thumbnail%20with%20person%20sitting%20peacefully%20by%20window%20with%20soft%20morning%20light%2C%20contemplative%20and%20healing%20atmosphere%2C%20warm%20golden%20tones%2C%20peaceful%20indoor%20setting%20with%20plants%2C%20serene%20and%20hopeful%20mood%2C%20intimate%20and%20comforting%20environment&width=800&height=450&seq=video-thumb-011&orientation=landscape',
      duration: '16:45',
      category: 'Inspiration',
      embedUrl: 'https://www.youtube.com/embed/k7X7sZzSXYs'
    },
    {
      id: '7',
      title: 'Healing Through Connection',
      description: 'Exploring how human connection, community support, and meaningful relationships play crucial roles in trauma recovery.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Heartwarming%20video%20thumbnail%20showing%20diverse%20group%20of%20people%20in%20supportive%20circle%2C%20warm%20community%20gathering%20atmosphere%2C%20natural%20outdoor%20setting%20with%20soft%20sunlight%2C%20genuine%20smiles%20and%20connection%2C%20inclusive%20and%20welcoming%20environment%2C%20authentic%20human%20interaction&width=800&height=450&seq=video-thumb-012&orientation=landscape',
      duration: '19:20',
      category: 'Inspiration',
      embedUrl: 'https://www.youtube.com/embed/fpD3tmBW0lM'
    },
    {
      id: '8',
      title: 'Breaking the Silence on Childhood Trauma',
      description: 'An important conversation about recognizing, addressing, and healing from childhood trauma with expert insights and survivor perspectives.',
      thumbnail: 'https://readdy.ai/api/search-image?query=Sensitive%20documentary%20video%20thumbnail%20with%20compassionate%20therapist%20in%20calm%20counseling%20office%2C%20soft%20diffused%20lighting%2C%20safe%20and%20supportive%20atmosphere%2C%20professional%20mental%20health%20setting%20with%20warm%20earth%20tones%2C%20trustworthy%20and%20caring%20environment%2C%20peaceful%20consultation%20room&width=800&height=450&seq=video-thumb-013&orientation=landscape',
      duration: '25:10',
      category: 'Education',
      embedUrl: 'https://www.youtube.com/embed/95ovIJ3dsNk'
    }
  ];

  const categories = ['All', 'Testimony', 'Inspiration', 'Education'];

  const filteredVideos = activeCategory === 'All' 
    ? videos 
    : videos.filter(video => video.category === activeCategory);

  const featuredVideo = videos.find(v => v.featured);
  const regularVideos = filteredVideos.filter(v => !v.featured);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        {/* Featured Video */}
        {featuredVideo && activeCategory === 'All' && (
          <div className="mb-20">
            <div className="flex items-center gap-3 mb-8">
              <i className="ri-star-fill text-2xl text-amber-500"></i>
              <h2 className="font-serif text-3xl font-bold text-gray-900">Featured Video</h2>
            </div>
            
            <div
              onClick={() => setSelectedVideo(featuredVideo)}
              className="group cursor-pointer"
            >
              <div className="relative rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300">
                <div className="relative w-full h-96 md:h-[500px]">
                  <img
                    src={featuredVideo.thumbnail}
                    alt={featuredVideo.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                {/* Play Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20 group-hover:from-black/90 group-hover:via-black/50 transition-all flex items-center justify-center">
                  <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-2xl">
                    <i className="ri-play-fill text-5xl text-teal-600 ml-2"></i>
                  </div>
                </div>

                {/* Featured Badge */}
                <div className="absolute top-6 left-6 bg-gradient-to-r from-amber-500 to-amber-600 text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg flex items-center gap-2">
                  <i className="ri-star-fill"></i>
                  <span>FEATURED</span>
                </div>

                {/* Duration Badge */}
                <div className="absolute top-6 right-6 bg-black/80 text-white text-sm font-medium px-4 py-2 rounded-full">
                  {featuredVideo.duration}
                </div>

                {/* Video Info Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="bg-teal-600 text-white text-sm font-medium px-4 py-1 rounded-full">
                      {featuredVideo.category}
                    </span>
                  </div>
                  <h3 className="font-serif text-4xl font-bold mb-3">
                    {featuredVideo.title}
                  </h3>
                  <p className="text-lg text-white/90 leading-relaxed max-w-3xl">
                    {featuredVideo.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Category Filter */}
        <div className="flex items-center justify-center gap-3 mb-16 flex-wrap">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === category
                  ? 'bg-teal-600 text-white shadow-lg shadow-teal-600/30'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* More Videos Title */}
        {featuredVideo && activeCategory === 'All' && regularVideos.length > 0 && (
          <div className="mb-8">
            <h3 className="font-serif text-2xl font-bold text-gray-900 mb-2">More Inspiring Videos</h3>
            <p className="text-gray-600">Explore additional content about trauma recovery, resilience, and hope</p>
          </div>
        )}

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {regularVideos.map((video) => (
            <div
              key={video.id}
              onClick={() => setSelectedVideo(video)}
              className="group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden mb-4 shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="relative w-full h-64">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                {/* Play Overlay */}
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors flex items-center justify-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-xl">
                    <i className="ri-play-fill text-3xl text-teal-600 ml-1"></i>
                  </div>
                </div>

                {/* Duration Badge */}
                <div className="absolute bottom-4 right-4 bg-black/80 text-white text-xs font-medium px-3 py-1 rounded-full">
                  {video.duration}
                </div>

                {/* Category Badge */}
                <div className="absolute top-4 left-4 bg-teal-600 text-white text-xs font-medium px-3 py-1 rounded-full">
                  {video.category}
                </div>
              </div>

              <h3 className="font-serif text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                {video.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed line-clamp-2">
                {video.description}
              </p>
            </div>
          ))}
        </div>

        {/* Video Modal */}
        {selectedVideo && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedVideo(null)}
          >
            <div
              className="bg-white rounded-2xl max-w-5xl w-full overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Video Player */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src={selectedVideo.embedUrl}
                  title={selectedVideo.title}
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              {/* Video Info */}
              <div className="p-8">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      {selectedVideo.featured && (
                        <span className="bg-gradient-to-r from-amber-500 to-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1">
                          <i className="ri-star-fill text-xs"></i>
                          FEATURED
                        </span>
                      )}
                      <span className="bg-teal-600 text-white text-xs font-medium px-3 py-1 rounded-full">
                        {selectedVideo.category}
                      </span>
                      <span className="text-sm text-gray-600">{selectedVideo.duration}</span>
                    </div>
                    <h2 className="font-serif text-3xl font-bold text-gray-900 mb-3">
                      {selectedVideo.title}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {selectedVideo.description}
                    </p>
                  </div>
                  <button
                    onClick={() => setSelectedVideo(null)}
                    className="ml-4 w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-xl text-gray-700"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
